import React from "react";
import styled from "styled-components";
import { Helmet } from "react-helmet";
import Card from "../../r2components/Card";
import ReactPlayer from "react-player";

const Header = styled.h1`
  text-align: center;
  margin: 40px;
`;

const Container = styled.div`
  align-items: center;
  max-width: 1000px;
  margin: auto;
  min-height: 800px;
`;

const CardDiv = styled.div``;

const CenteringWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
`;

const CardsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;
  & > :not(:last-child) {
    margin-right: 24px;
  }
  & > * > * > * {
    width: 300px;
  }
`;

const LearnHome: React.FC<{}> = () => {
  return (
    <>
      <Helmet>
        <title>Learn Semgrep | Semgrep</title>
      </Helmet>
      <Container>
        <Header>Learn Semgrep</Header>
        <CardsWrapper>
          <CardDiv>
            <Card header="Basics Tutorial" linkTo="/learn/basics/1">
              Learn to write Semgrep rules in under 10 minutes! Many useful
              rules do not require complex logic.
            </Card>
          </CardDiv>
          <CardDiv>
            <Card header="Pattern Composition" linkTo="/learn/composition/1">
              Write more nuanced rules, with logic operators like
              "pattern-either" and "pattern-inside".
            </Card>
          </CardDiv>
          <CardDiv>
            <Card header="Advanced Features" linkTo="/learn/advanced/1">
              Become a power-user, familiar with all of Semgrep's latest and
              greatest features.
            </Card>
          </CardDiv>
        </CardsWrapper>
        <CenteringWrapper>
          <ReactPlayer url="https://www.youtube.com/watch?v=BAdfmzJdO68" />
        </CenteringWrapper>
      </Container>
    </>
  );
};

export default LearnHome;
